import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/local-network-access-prompt.png'


const _hoisted_1 = { class: "mt-2 text-sm text-red-700 dark:text-red-300 flex items-center flex-wrap" }

import { ref, inject, computed } from 'vue'
import { useTheme } from '../../utils/useTheme'

const TOOLTIP_HEIGHT = 280 // Approximate height of the tooltip


export default /*@__PURE__*/_defineComponent({
  __name: 'NetworkAccessHint',
  setup(__props) {

const theme = inject('theme', useTheme())
const isDark = computed(() => theme.isDark.value)

// Tooltip state
const tooltipTrigger = ref<HTMLElement | null>(null)
const tooltipVisible = ref(false)
const tooltipPosition = ref<'above' | 'below'>('below')

const showTooltip = () => {
  if (tooltipTrigger.value) {
    const rect = tooltipTrigger.value.getBoundingClientRect()
    const spaceAbove = rect.top
    const spaceBelow = window.innerHeight - rect.bottom

    // Prefer showing below, but show above if not enough space below and more space above
    if (spaceBelow < TOOLTIP_HEIGHT && spaceAbove > spaceBelow) {
      tooltipPosition.value = 'above'
    } else {
      tooltipPosition.value = 'below'
    }
  }
  tooltipVisible.value = true
}

const hideTooltip = () => {
  tooltipVisible.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("span", null, "This may happen if you haven't provided local network access to this site.", -1)),
    _createElementVNode("div", {
      ref_key: "tooltipTrigger",
      ref: tooltipTrigger,
      class: "relative ml-1",
      onMouseenter: showTooltip,
      onMouseleave: hideTooltip
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("svg", {
        class: "h-4 w-4 text-red-500 dark:text-red-400 cursor-help",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        })
      ], -1)),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass([
          'absolute z-50 left-1/2 transform -translate-x-1/2',
          tooltipPosition.value === 'above' ? 'bottom-full mb-2' : 'top-full mt-2'
        ])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([
            isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
            'border rounded-lg shadow-lg p-2 w-80'
          ])
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("p", { class: "text-xs text-gray-600 dark:text-gray-300 mb-2" }, " When prompted, click \"Allow\" to grant local network access: ", -1),
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Local Network Access Permission Dialog",
            class: "w-full rounded border border-gray-200 dark:border-gray-600"
          }, null, -1)
        ]), 2),
        (tooltipPosition.value === 'above')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([
            isDark.value ? 'border-t-gray-800' : 'border-t-white',
            'absolute left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent'
          ])
            }, null, 2))
          : _createCommentVNode("", true),
        (tooltipPosition.value === 'below')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([
            isDark.value ? 'border-b-gray-800' : 'border-b-white',
            'absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-full w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent'
          ])
            }, null, 2))
          : _createCommentVNode("", true)
      ], 2), [
        [_vShow, tooltipVisible.value]
      ])
    ], 544)
  ]))
}
}

})